import * as Yup from 'yup';

export const getEntrySchema = (entryTypeIndex) => {
  return Yup.object({
    locationID: Yup.string().required('Оберіть локацію'),
    date: Yup.string().required('Оберіть дату'),
    startTime: Yup.string().required('Вкажіть час початку'),
    hallID: Yup.string().required('Оберіть залу'),

    clients: Yup.array().test('clients-required', 'Потрібно додати хоча б одного клієнта', function (clients) {
      if (entryTypeIndex === 0) {
        const filledClients = clients?.filter(({ client }) => client?.trim() !== '') || [];
        return filledClients.length > 0;
      }
      return true;
    }),

    coaches: Yup.array().of(
      Yup.object({
        coach: Yup.string(),
        price: Yup.string().nullable(),
      })
    ),

    group: Yup.string(),
    service: Yup.string(),
    comment: Yup.string(),
  });
};
